@let texts = resourcesService.languageFile.value();
@if (store.showHint()) {
  <div class="hint-inner-container">
    <gis-panel [buttonIcon]="PanelButtonIcon.Lightbulb"
      [buttonLabel]="texts.hint"
      [buttonLabelSuffix]="`(-${store.hintReduction()} pt)`"
      [position]="buttonPosition()"
      [isOverlay]="true"
      (isToggled)="onIsToggled()">
      <div class="hint-heading">
        <h2 class="header">{{ texts.hintHeader }}</h2>
      </div>
      <div class="hint-content">{{ store.currentQuestion()?.hint }}</div>
    </gis-panel>
  </div>
}
